import Vue from 'vue'
import {
    Timeline,
    Aside,
    Dialog,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Input,
    InputNumber,
    Radio,
    RadioGroup,
    RadioButton,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Switch,
    Select,
    Option,
    OptionGroup,
    Button,
    ButtonGroup,
    Table,
    TableColumn,
    DatePicker,
    TimeSelect,
    TimePicker,
    Popover,
    Tooltip,
    Form,
    FormItem,
    Tabs,
    Tag,
    Tree,
    Alert,
    Icon,
    Row,
    Col,
    Upload,
    Progress,
    Card,
    Rate,
    Container,
    Header,
    Main,
    Footer,
    Image,
    Calendar,
    Backtop,
    Loading,
    Drawer,
    Carousel,
    Step,
    Steps,
    Scrollbar,
    CarouselItem,
    Cascader,
    TabPane,
    Collapse,
    CollapseItem,
    Pagination
} from 'element-ui';

Vue.use(Timeline);
Vue.use(Aside);
Vue.use(Pagination);
Vue.use(TabPane);
Vue.use(CarouselItem);
Vue.use(Cascader);
Vue.use(Scrollbar)
Vue.use(Step);
Vue.use(Steps);
Vue.use(Carousel);
Vue.use(Drawer);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Steps);
Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Image);
Vue.use(Calendar);
Vue.use(Backtop);
Vue.use(Collapse);
Vue.use(CollapseItem);


/*Vue.use(MessageBox);
Vue.use(Notification);*/




Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;


Vue.prototype.$ELEMENT={ size: 'small', zIndex: 3000 };
